import initializeIziButton from "./woocommerceizi/initializeIziButton";
import unboundWidgetClicked from "./woocommerceizi/unboundWidgetClicked";
import handleBasketEvent from "./woocommerceizi/handleBasketEvent";
import refreshIziButton from "./woocommerceizi/refreshIziButton";
import elementorRefreshIziButton from "./woocommerceizi/elementorRefreshIziButton";
import refreshSingleProductPage from "./woocommerceizi/refreshSingleProductPage";
import getBasketBindingApiKeyFromCookie from "./woocommerceizi/getBasketBindingApiKeyFromCookie";
import setupAnalytics from "./woocommerceizi/setupAnalytics";
import { inpostPayBinding } from "./woocommerceizi/inpostPayBinding";
import { autoClickIziButtonIfCurrencyRestored } from "./woocommerceizi/autoClickIziButtonIfCurrencyRestored";

if (typeof InpostIziJavsscriptWoocommerce === "object") {
  window.addEventListener("load", async function () {
    const basketIdFromCookie = getBasketBindingApiKeyFromCookie();
    if (
      IPPWidgetOptions &&
      typeof basketIdFromCookie === "string" &&
      basketIdFromCookie.trim() !== "" &&
      basketIdFromCookie !== "undefined"
    ) {
      IPPWidgetOptions.basketBindingApiKey = basketIdFromCookie.trim();
    } else if (IPPWidgetOptions) {
      try {
        const response = await fetch(
          InpostIziJavsscriptWoocommerce.basket_binding_api_key.toString(),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        await response.json().then((data) => {
          IPPWidgetOptions.basketBindingApiKey = data.basket_binding_api_key;
        });
      } catch (error) {
        throw new Error("cd2e2b76-e91f-4836-96db-0a35855544a2");
      }
    }

    window.IPPwidget = InPostPayWidget.init(IPPWidgetOptions);
    initializeIziButton();
    setupAnalytics();
    observeCountBadge();
    const currencyWasRestored = Boolean(
      window.InpostIziJavsscriptWoocommerce?.currency_restored,
    );
    autoClickIziButtonIfCurrencyRestored(currencyWasRestored);
  });

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      IPPWidgetOptions.unboundWidgetClicked = unboundWidgetClicked;
      IPPWidgetOptions.handleBasketEvent = handleBasketEvent;
      refreshIziButton();
      elementorRefreshIziButton();
      refreshSingleProductPage();
    },
    false,
  );
}

function observeCountBadge() {
  let lastBadgePresent = false;
  let shadowObserver = null;

  function handleBadgeChange() {
    const iziButton = document.querySelector("inpost-izi-button");
    if (iziButton && iziButton.shadowRoot) {
      const badge = iziButton.shadowRoot.querySelector(".count-badge");
      if (badge && !lastBadgePresent) {
        lastBadgePresent = true;
        inpostPayBinding();
      } else if (!badge && lastBadgePresent) {
        lastBadgePresent = false;
      }
    } else {
      lastBadgePresent = false;
    }
  }

  const domObserver = new MutationObserver(() => {
    const iziButton = document.querySelector("inpost-izi-button");
    if (iziButton && iziButton.shadowRoot) {
      if (!shadowObserver) {
        shadowObserver = new MutationObserver(handleBadgeChange);
        shadowObserver.observe(iziButton.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }
      handleBadgeChange();
    } else {
      if (shadowObserver) {
        shadowObserver.disconnect();
        shadowObserver = null;
      }
      lastBadgePresent = false;
    }
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  setInterval(handleBadgeChange, 200);
}
